import { render, staticRenderFns } from "./ex-live-tool.vue?vue&type=template&id=a126294e&scoped=true&"
import script from "./ex-live-tool.vue?vue&type=script&lang=js&"
export * from "./ex-live-tool.vue?vue&type=script&lang=js&"
import style0 from "./ex-live-tool.vue?vue&type=style&index=0&id=a126294e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a126294e",
  null
  
)

export default component.exports